import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function CustomerRegister() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [busy, setBusy] = useState(false);

    const upd = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (form.password.length < 6) return toast.error("Password com pelo menos 6 caracteres");
        setBusy(true);
        try {
            await register(form.name, form.email, form.password, form.phone);
            toast.success("Conta criada!");
            nav("/conta");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro ao registar");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="container-edge py-16 max-w-xl" data-testid="customer-register-page">
            <div className="label-mono text-magenta">Nova conta</div>
            <h1 className="font-display font-black text-4xl tracking-tighter mt-2 mb-8">
                Criar conta SOSTONERS
            </h1>
            <form onSubmit={submit} className="border-2 border-ink bg-white p-8 space-y-4">
                <Field label="Nome completo *" v={form.name} on={upd("name")} testid="reg-name" required />
                <Field label="Email *" type="email" v={form.email} on={upd("email")} testid="reg-email" required />
                <Field label="Telefone" v={form.phone} on={upd("phone")} testid="reg-phone" />
                <Field label="Password *" type="password" v={form.password} on={upd("password")} testid="reg-password" required />
                <button
                    type="submit"
                    disabled={busy}
                    className="btn-primary w-full disabled:opacity-50"
                    data-testid="customer-register-btn"
                >
                    {busy && <Loader2 className="animate-spin" size={16} />}
                    {busy ? "A registar…" : "Criar Conta"}
                </button>
                <div className="text-sm font-mono text-center pt-2">
                    Já tem conta?{" "}
                    <Link to="/conta/login" className="text-magenta font-bold">
                        Iniciar sessão
                    </Link>
                </div>
            </form>
        </div>
    );
}
function Field({ label, v, on, type = "text", required, testid }) {
    return (
        <label className="block">
            <span className="label-mono mb-2 block">{label}</span>
            <input type={type} value={v} onChange={on} required={required} className="input-edge" data-testid={testid} />
        </label>
    );
}
